export default __webpack_public_path__ + "static/media/sold-out.68a5043f.jpg";